const STORAGE_KEY = 'onboarding_tooltips';

function load() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function save(state) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export const tooltipState = {
  hasSeen(id) {
    return Boolean(load()[id]?.seen);
  },

  markSeen(id) {
    const state = load();
    state[id] = { ...state[id], seen: true };
    save(state);
  },

  getFlowStep(flowId) {
    return load()[flowId]?.step ?? 0;
  },

  setFlowStep(flowId, step) {
    const state = load();
    state[flowId] = { ...state[flowId], step };
    save(state);
  },

  reset(id) {
    const state = load();
    delete state[id];
    save(state);
  },

  resetAll() {
    localStorage.removeItem(STORAGE_KEY);
  },
};

export default tooltipState;
